import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../hooks'
import Dashboard from './Dashboard'

export default function Home() {

    const authenticated = useAppSelector((state) => state.auth.authenticated)

    if (authenticated) {
        return <Dashboard />
    }

    return <Navigate to="/login" replace />
}